export default __webpack_public_path__ + "static/media/210809 bokoblin rider.e8f1a080.png";